import PricingPlan from "./PricingPlan";
import { monthlyPlan, yearlyPlan } from "../../constants/Subscription";
import { useEffect, useState } from "react";
import { Plan } from "../../@types/subscripton";

interface SubscriptionBoxProps {
  show: (plan: string) => void;
  isChoosing: boolean;
  indexState: number | null;
}

const SubscriptionBox = ({
  show,
  isChoosing,
  indexState,
}: SubscriptionBoxProps) => {
  const [month, setMonth] = useState(true);
  const [year, setYear] = useState(false);
  const [plans, setPlans] = useState<Plan[]>([]);
  const handleMonthly = () => {
    setMonth(true);
    setYear(false);
    setPlans([...monthlyPlan]);
  };
  const handleYearly = () => {
    setMonth(false);
    setYear(true);
    setPlans([...yearlyPlan]);
  };
  useEffect(() => {
    handleMonthly();
  }, []);
  return (
    <>
      <div className="w-full relative z-50 s">
        <div className="flex justify-center lg:mb-[64px]">
        <div className="flex items-center bg-[#BBDDFC] rounded-lg p-1 w-fit">
  <button
    onClick={handleMonthly}
    className={`${
      month && !year ? "bg-white shadow text-[#111827]" : "bg-transparent text-[#6B7280]"
    } font-semibold text-[16px] px-5 py-2 rounded-lg transition-all`}
  >
    MONTHLY
  </button>
  <button
    onClick={handleYearly}
    className={`flex items-center gap-2 font-semibold text-[16px] px-5 py-2 rounded-lg transition-all ${
      year && !month ? "bg-white shadow text-[#111827]" : "bg-transparent text-[#6B7280]"
    }`}
  >
    YEARLY
    <span className={`bg-[#FFC26D] text-[#82310C] text-[14px]  px-3 py-1 rounded-md ${
      year ? "opacity-100" : "opacity-70"
    }`}>
      Save 20%
    </span>
  </button>
</div>

        </div>
        <div className="flex flex-col gap-4 md:gap-0 md:flex-row md:justify-center md:items-center w-full mt-[1em] pb-10">
          {plans.map((plan, index) => (
            <PricingPlan
              key={index}
              discount={plan.discount}
              title={plan.title}
              price={plan.price}
              features={plan.features}
              buttonText={plan.buttonText}
              plan={plan.plan}
              index={index}
              show={show}
              duration={plan.duration}
              subPrice={plan.subPrice}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SubscriptionBox;
